import React, { useEffect, useState, useRef } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    DropdownToggle,
    Button,
    Modal,
    FormGroup,
    Form,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { Link } from "react-router-dom"
import Breadcrumb from "../../components/Common/Breadcrumb"
// Import images
import substrateImg from "../../assets/images/SubstrateImg.png"
import fruitingImg from "../../assets/images/fruiting1.png"

import "../Batch/datatables.scss"
import { useFormik } from "formik"
import * as Yup from "yup"
import axios from "axios"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatatableTables = props => {
    document.title = "Reports | My Urban Farms"
    const adminKey = sessionStorage.getItem("pk_admin_key");
    const farmKey = sessionStorage.getItem("pk_farm_key");


    const breadcrumbItems = []

    const [batchList, setBatchList] = useState([])
    const [reports, setReports] = useState([])
    const [noResults, setNoResults] = useState(false);

    const [isLoading, setIsLoading] = useState(false)

    const [selectedBatch, setSelectedBatch] = useState("");
    

    useEffect(() => {
        props.setBreadcrumbItems("Reports", breadcrumbItems)
        fetchBatches();
        // fetchReportsByBatch();
    }, [])

    const [selectedDate, setSelectedDate] = useState("");

    const [showBatchDropdown, setShowBatchDropdown] = useState(false);



    const fetchBatches = async () => {
        setIsLoading(true)
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getAllBatchesForReports/batch/`,
                {farmKey: farmKey}
            )
            const resData = response.data
            setIsLoading(false)

            if (resData.message?.success && Array.isArray(resData.message.data)) {
                setBatchList(resData.message.data)

                const tableRows = resData.message.data.map((item, index) => ({
                    sno: index + 1,
                    batch_name: item.batch_name,
                    batch_num: item.batch_num,
                    bag_num: item.bags_count || 0,
                    process_name: item.current_stage || item.process_name || "",
                    process_date: item.start_date
                }));
                setReports(tableRows);
                setNoResults(false);

            } else {
                console.warn("Unexpected data format", resData)
                setBatchList([])
            }
        } catch (error) {
            console.error("Failed to fetch batch list:", error)
            setIsLoading(false)
            setBatchList([])
            toast.error("Failed to fetch batches!", { autoClose: 3000 })
        }
    }



    const [showPicker, setShowPicker] = useState(false);


    const fetchReportsByBatch = async (batchKey, dateFilter = "") => {
        setReports([]);
        try {
            const res = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/getReportsByBatch/reports/`,
                { 
                    batch_key: batchKey, 
                    farmKey: farmKey,
                    selected_date: dateFilter
                }
            );

            const list = res.data.message?.data || [];
            if (list.length === 0) { 
                 setReports([]);
                setNoResults(true);
                return;
            }

            setNoResults(false);

            const tableRows = list.map((item, index) => ({
                sno: index + 1,
                batch_name: item.batch_name,
                batch_num: item.batch_num,
                bag_num: item.bag_num,
                process_name: item.process_name,
                process_date: item.process_date
            }));

            setReports(tableRows);

        } catch (error) {
            console.error(error);
            setReports([]);
            toast.error("Failed to fetch batch reports");
        }
    };


    const data = {
        columns: [
            { label: "S.No", field: "sno", sort: "asc", width: 50 },
            { label: "Batch Name", field: "batch_name", sort: "asc" },
            { label: "Batch Number", field: "batch_num", sort: "asc" },
            { label: "Bag Number", field: "bag_num", sort: "asc" },
            { label: "Process Name", field: "process_name", sort: "asc" },
            { label: "Process Date", field: "process_date", sort: "asc" }
        ],
        rows: []
    };
    const [hasUserSelected, setHasUserSelected] = useState(false);

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb />
                <div className="d-flex justify-content-end gap-2">
                    
                    <div style={{ position: "relative" }}>
                        <Button
                            color="primary"
                            onClick={() => setShowPicker(!showPicker)}
                            style={{ minWidth: "140px" }}
                        >
                            <i className="mdi mdi-calendar"></i>{" "}
                            {selectedDate ? selectedDate : "Select Date"}
                        </Button>

                        {showPicker && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "45px",
                                    zIndex: 20,
                                }}
                            >
                                <DatePicker
                                    selected={selectedDate ? new Date(selectedDate) : null}
                                    onChange={(date) => {
                                        if (!date) {
                                            setSelectedDate("");
                                            setShowPicker(false);
                                            return;
                                        }

                                        const formatted =
                                            date.getFullYear() +
                                            "-" + String(date.getMonth() + 1).padStart(2, "0") +
                                            "-" + String(date.getDate()).padStart(2, "0");

                                        setSelectedDate(formatted);
                                        setShowPicker(false);
                                        setHasUserSelected(true);
                                        setNoResults(false);

    
                                        if (selectedBatch) {
                                            const selectedBatchObj = batchList.find(b => b.batch_num === selectedBatch);
                                            if (selectedBatchObj) {
                                                fetchReportsByBatch(selectedBatchObj.pk_batch_key, formatted);
                                                return;
                                            }
                                        }

    
                                        setSelectedBatch("");

                                        axios.post(
                                            `${process.env.REACT_APP_API_BASE_URL}/getReports/reports/`,
                                            { selected_date: formatted, farmKey: farmKey }
                                        )
                                        .then((res) => {
                                            const list = res.data.message?.data || [];
                                            if (list.length === 0) {
                                                setReports([]);
                                                setNoResults(true);
                                                return;
                                            }
                                            setNoResults(false);
                                            setReports(list.map((item, i) => ({
                                                sno: i + 1,
                                                batch_name: item.batch_name,
                                                batch_num: item.batch_num,
                                                bag_num: item.bag_num,
                                                process_name: item.process_name,
                                                process_date: item.process_date
                                            })));
                                        })
                                        .catch((err) => {
                                            console.error("ERROR:", err);
                                            setReports([]);
                                            setNoResults(true);
                                            toast.error("Failed to fetch reports for selected date");
                                        });
                                    }}
                                    inline
                                />
                            </div>
                        )}
                    </div>

                    <div style={{ position: "relative" }}>
                        <Button
                            color="primary"
                            onClick={() => setShowBatchDropdown(!showBatchDropdown)}
                            style={{ minWidth: "140px" }}
                        >
                            <i className="mdi mdi-file-cabinet me-1"></i>
                            {selectedBatch ? selectedBatch : "Select Batch"}
                        </Button>

                        {showBatchDropdown && (
                            <div
                                style={{
                                    position: "absolute",
                                    top: "45px",
                                    zIndex: 20,
                                    background: "#fff",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc",
                                    width: "180px",
                                    maxHeight: "220px",
                                    overflowY: "auto",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                                    padding: "5px 0"
                                }}
                            >
                                {batchList.length === 0 && (
                                    <div
                                        style={{
                                            padding: "10px",
                                            textAlign: "center",
                                            color: "#777"
                                        }}
                                    >
                                        No Batches
                                    </div>
                                )}

                                {batchList.map((batch) => (
                                    <div
                                        key={batch.pk_batch_key}
                                        onClick={() => {
                                            setSelectedBatch(batch.batch_num);
                                            setShowBatchDropdown(false);
                                            setHasUserSelected(true);
                                            setNoResults(false); 
                                            // setSelectedDate("");
                                            setHasUserSelected(true);
                                            fetchReportsByBatch(batch.pk_batch_key, selectedDate);
                                        }}
                                        style={{
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            fontSize: "14px",
                                        }}
                                        onMouseEnter={e => e.target.style.background = "#f0f0f0"}
                                        onMouseLeave={e => e.target.style.background = "transparent"}
                                    >
                                        {batch.batch_num}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>




                </div>
            </div>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <MDBDataTable
                                responsive
                                striped
                                bordered
                                // data={{ ...data, rows: reports }}
                                data={{ ...data, rows: reports }}
                                noBottomColumns
                                noRecordsFoundLabel={
                                    hasUserSelected
                                        ? "No records found"
                                        : "Select Date or Batch to view details"
                                }

                            // noBottomColumns
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>


        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(DatatableTables)
